export default __webpack_public_path__ + "static/media/Australia_07.8ee95d40.png";